<template>
  <section class="main">
    <h1 class="intro">{{ $t('REFER-A-FRIEND') }}</h1>
    <div class="row">
      <div class="col col_1">
        <h2 class="h2">Your referral link</h2>
        <p class="text g-text">
          Each PLUS activation of device referred by you gives 2 EUR to your
          referrer fund. Share this link with your friends.
        </p>
        <span class="link">{{ link }}</span>
        <button class="button g-button" v-clipboard:copy="link">Copy link</button>
        <div class="blocks">
          <div class="block">
            <h2 class="block__heading">Funds Balance</h2>
            <img src="@/assets/icon-wallet.svg" class="block__icon" />
            <span class="block__text">2 EUR</span>
            <ul class="block__list">
              <li class="block__item">
                <span class="block__item-text">Pending gift requests:</span>
                10 EUR
              </li>
              <li class="block__item">
                <span class="block__item-text">Redeemed for Gifts:</span>
                220 EUR
              </li>
              <li class="block__item">
                <span class="block__item-text">{{ $t('TOTAL COLLECTED') }}:</span>
                230 EUR
              </li>
            </ul>
          </div>
          <div class="block">
            <h2 class="block__heading">{{ $t('AVAILABLE GIFTS') }}</h2>
            <img src="@/assets/icon-pro.svg" class="block__icon" />
            <span class="block__text block__text_small"
              >PayPal transfer</span
            >
            <button class="block__button block__button_disabled">Redeem</button>
            <span class="block__warning">Insufficient funds to redeem</span>
          </div>
        </div>
      </div>
      <aside class="sidebar col col_2">
        <h2 class="sidebar__heading">Referral Program</h2>
        <p class="g-text" v-html="$t('REFER-A-FRIEND_DESC')">
        </p>
      </aside>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    link() {
      return `https://appdb.to?ref_code=${this.$store.getters.config.ref_code}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
  flex-grow: 1;
}

.row {
  display: flex;
  align-items: flex-start;

  @include notebook {
    flex-wrap: wrap;
  }
}

.col {
  &_1 {
    flex-grow: 1;

    @include notebook {
      order: 1;
      margin-top: 15px;
    }
  }

  &_2 {
    flex: 0 0 192px;
    margin-left: 15px;

    @include notebook {
      margin-left: 0;
      order: 0;
    }
  }

  @include notebook {
    flex: 0 0 100%;
  }
}

.h2 {
  font-weight: 500;
  margin-bottom: 15px;
}

.link {
  background: #f0f4fb;
  display: block;
  padding: 5px;
  margin: 10px 0;
}

.sidebar {
  background: var(--secondary-bg);
  border-radius: 8px;
  padding: 10px;

  &__heading {
    font-weight: 500;
    margin-bottom: 10px;
  }
}

.blocks {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;

  @include notebook {
    flex-wrap: wrap;
  }
}

.block {
  flex: 0 0 48%;
  padding: 10px 30px;
  background: var(--secondary-bg);
  border-radius: 8px;
  text-align: center;

  @include notebook {
    flex: 0 0 100%;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }

  &__heading {
    font-size: 16px;
    font-weight: 600;
  }

  &__icon {
    margin: 15px 0 10px;
  }

  &__text,
  &__list {
    max-width: 300px;
    width: 100%;
  }

  &__text {
    display: block;
    font-size: 20px;
    font-weight: 500;
    padding-bottom: 15px;
    border-bottom: 1px solid #e5e5e5;

    &_small {
      font-size: 16px;
      display: inline-block;
    }
  }

  &__list {
    margin-top: 15px;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    margin-bottom: 5px;
  }

  &__item-text {
    color: $primary;
  }

  &__button {
    display: inline-block;
    width: 163px;
    color: #fff;
    background: $primary;
    box-shadow: 0 2px 4px 0 rgba(35, 69, 114, 0.3);
    border-radius: 2px;
    padding: 7px;
    margin-bottom: 10px;
    margin-top: 15px;
    font-size: 14px;

    &_disabled {
      pointer-events: none;
      opacity: 0.3;
    }
  }

  &__warning {
    font-size: 12px;
  }
}
</style>
